/**
 * Event
 * An abstraction so we can tramsit custom events.
 *
 * ## Example
 * `new Event('myCustomEvent`, {
 *    category: 'event',
 *    action: 'clickedButton',
 *    value: 123
 * });`
 */
class Event {
	/**
	 * @param  {string} name    Name of the event
	 * @param  {Object} data    [description]
	 * @param  {Object} options Which services to use
	 */
	constructor(name, data = {
		category: '',
		action: '',
		value: '',
	}, options = {
		gtm: true,
		adobe: true,
		ga: true,
	}) {
		Object.keys(options).forEach((provider) => {
			if (!provider) {
				return;
			}
			this[provider](name, data);
		});
	}

	/**
	 * Google Tag Manager
	 */
	gtm(name, data) {
		if (process.env.NODE_ENV === 'production') {
			// no data layer
			if (typeof dataLayer === 'undefined' || !dataLayer) {
				return;
			}
			// push the data to the data layer
			// Variable names should be enclosed in quotes
			dataLayer.push({
				'event': 'GAevent',
				'eventCategory': data.category || '',
				'eventAction': data.action,
				'eventLabel': data.label || '',
				'eventValue': data.value || '',
			});
		} else {
			// dev mode output to console log
			console.log('--- GTM Event ---');
			console.log('eventCategory:', data.category || '');
			console.log('eventAction:', data.action || '');
			console.log('eventLabel:', data.label || '');
			console.log('eventValue:', data.value || '');
			console.log('----------------');
		}
	}

	/**
	 * Adobe Site Catalyst
	 */
	adobe(name, data) {

	}

	/**
	 * Google Analytics
	 */
	ga(name, data) {
		if (process.env.NODE_ENV === 'production') {
			if (typeof ga === 'undefined' || !ga) {
				// the ga global isn't available
				return;
			}
			// transmit the data to GA
			ga('send', {
				hitType: 'event',
				eventCategory: data.category || '',
				eventAction: data.action || '',
				eventLabel: data.label || '',
				eventValue: data.value || '',
			});
		} else {
			// dev mode output to console log
			console.log('--- GA Event ---');
			console.log('eventCategory:', data.category || '');
			console.log('eventAction:', data.action || '');
			console.log('eventLabel:', data.label || '');
			console.log('eventValue:', data.value || '');
			console.log('----------------');
		}
	}
}

export default Event;